// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"333ba228","455":"e7e90836"}[chunkId] + ".chunk.js";
};